// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--14l5w";
export var inner = "footer-module--inner--yV07t";
export var nav = "footer-module--nav--Cvhh_";
export var discord = "footer-module--discord--23nv_";
export var img = "footer-module--img--1AHg5";
export var disclaimer = "footer-module--disclaimer--2R9cx";